import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

class ProductPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * Updates the price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice = (event) => {
    const { data } = event.detail;
    const product = data.product || data.newProduct;
    if (!product) return;

    // Check if product has tag "pm"
    const isPerMeter = product.tags && product.tags.includes('pm');

    const newPrice = data.html.querySelector('product-price [ref="priceContainer"]');
    const currentPrice = this.querySelector('[ref="priceContainer"]');

    if (!newPrice || !currentPrice) return;

    // If no change in HTML, skip
    if (currentPrice.innerHTML === newPrice.innerHTML) return;

    // --- Custom Logic: Apply PM adjustments before replacing ---
    if (isPerMeter) {
      const priceElems = newPrice.querySelectorAll('.price, .compare-at-price');

      priceElems.forEach(el => {
        const moneyText = el.textContent.trim();
        const amount = parseFloat(moneyText.replace(/[^0-9.]/g, '')); // Get numeric part

        if (!isNaN(amount)) {
          const currencySymbol = moneyText.replace(/[0-9.,\s]/g, '');
          const newAmount = amount * 2;

          el.textContent = `${currencySymbol}${newAmount.toFixed(2)}/meter`;
        }
      });

      // Optional: Handle quantity display if you have a reference to it
      const qtyEl = this.closest('[ref="product"]').querySelector('[ref="quantityInput"]');
      if (qtyEl && qtyEl.value) {
        const originalQty = parseFloat(qtyEl.value);
        if (!isNaN(originalQty)) {
          qtyEl.value = (originalQty / 2).toFixed(2);
        }
      }
    }

    // Replace HTML
    currentPrice.replaceWith(newPrice);
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
